import { useReward } from '@/contexts/reward-context';
import { RewardScene, VoucherType } from '@/types';
import { addCommas, replaceResource } from '@/utils';
import { useEffect, useRef, useState } from 'react';
import { CloseIcon } from './svg-icons';
import { CoinIcon } from '@/components/icons/coin-icon';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

type voucherStatus = 'canBuy' | 'soldOut' | 'reachLimit' | 'noPermission' | 'outOfMoney';

export const PurchaseConfirm = () => {
	const buttonRef = useRef<HTMLButtonElement>(null);
	const { labels, setPlanInfo, planInfo, cartVoucher, setRewardScene, purchaseVoucher, setPurchaseMessage, onKafkaSet } = useReward();
	const [status, setStatus] = useState<voucherStatus>('canBuy');

	const onClose = () => {
		setRewardScene(RewardScene.Shop);
	};

	const purchase = () => {
		if (buttonRef.current) {
			buttonRef.current.disabled = true;
		}

		let action;

		switch (cartVoucher?.VoucherType as number) {
			case VoucherType.OddsBooster:
				action = 33;
				break;
			case VoucherType.RiskFreeBet:
			case VoucherType.NewRiskFreeBet:
				action = 34;
				break;
			case VoucherType.CashExchange:
				action = 36;
				break;
			default:
				action = 35;
				break;
		}

		onKafkaSet({
			type: 3,
			action: action
		});

		if (purchaseVoucher && status && cartVoucher?.VoucherDetailId) {
			purchaseVoucher(cartVoucher?.VoucherDetailId).then(() => {
				if (planInfo?.SabaCoin && setPlanInfo) {
					planInfo.SabaCoin = Number((planInfo.SabaCoin - cartVoucher.Price).toFixed(2));
					setPlanInfo(planInfo);
				}

				if (setPurchaseMessage) {
					setPurchaseMessage(cartVoucher?.LimitPerPeriod ? (labels?.lbl_RPRedeemSuccess as string) : (labels?.lic_loyaltyExchangeDone as string));
					onClose();
				}
			}, ({ message }) => {
				if (setPurchaseMessage) {
					setPurchaseMessage(message);
					onClose();
				}
			})
		}
	};

	useEffect(() => {
		if ((cartVoucher?.QuantitySold as number) >= (cartVoucher?.LimitPerPeriod as number) && cartVoucher?.LimitPerPeriod) {
			setStatus('soldOut');
		} else if ((cartVoucher?.PurchasedCountByUser as number) >= (cartVoucher?.LimitPerUser as number) && cartVoucher?.LimitPerUser) {
			setStatus('reachLimit');
		} else if (!cartVoucher?.CanBuy && !cartVoucher?.VoucherDetailId) {
			setStatus('noPermission');
		} else if ((cartVoucher?.Price as number) > (planInfo?.SabaCoin as number)) {
			setStatus('outOfMoney');
		}
	}, []);

	return (
		<RewardModalWrapper>
			<div className="shop-voucher-modal">
				<div
					className="shop-voucher-modal__close"
					onClick={onClose}
				>
					<CloseIcon />
				</div>
				<div className="shop-voucher-modal__main">
					<div className="shop-voucher-detail">
						<div className="shop-voucher-detail__header">
							<span className="shop-voucher-detail__title">{labels?.[cartVoucher?.Name ?? '']}</span>
							<div className="reward-coin">
								<CoinIcon />
								<div className="reward-coin__text">{addCommas(planInfo?.SabaCoin ?? 0)}</div>
							</div>
						</div>
						{
							cartVoucher?.VoucherType != VoucherType.NicknameChange && (
								<div className="shop-voucher-detail__body reward-scroller">
									<h4>{labels?.lbl_RPVoucherDetails}</h4>
									<p>{replaceResource(labels?.[cartVoucher?.Description ?? ''] as string, `${cartVoucher?.QuotaAfterRate}`)}</p>
									{
										cartVoucher?.VoucherType == VoucherType.OddsBooster &&
										<>
											<h4>{labels?.lbl_RPUsageRules}</h4>
											<ol>
												<li>{labels?.lbl_RPVoucherRules1}</li>
												<li>{labels?.lbl_RPVoucherRules10}</li>
												<li>{labels?.lbl_RPVoucherRules11}</li>
												<li>{labels?.lbl_RPVoucherRules3}</li>
												<li>{labels?.lbl_RPVoucherRules5}</li>
												<li>{labels?.lbl_RPVoucherRules6}</li>
												<li>{labels?.lbl_RPVoucherRules7}</li>
												<li>{labels?.lbl_RPVoucherRules8}</li>
												<li>{labels?.lbl_RPVoucherRules9}</li>
											</ol>
										</>
									}
									{
										cartVoucher?.VoucherType == VoucherType.RiskFreeBet &&
										(
											<>
												<h4>{labels?.lbl_RPUsageRules}</h4>
												<ol>
													<li>{labels?.lbl_RPVoucherRules1}</li>
													<li>{labels?.lbl_RPVoucherRules2}</li>
													<li>{labels?.lbl_RPVoucherRules3}</li>
													{/* <li>{labels?.lbl_RPVoucherRules4}</li> */} {/* No this market */}
													<li>{labels?.lbl_RPVoucherRules5}</li>
													<li>{labels?.lbl_RPVoucherRules6}</li>
													<li>{labels?.lbl_RPVoucherRules7}</li>
													<li>{labels?.lbl_RPVoucherRules8}</li>
													<li>{labels?.lbl_RPVoucherRules9}</li>
												</ol>
											</>
										)
									}
									{
										cartVoucher?.VoucherType == VoucherType.NewRiskFreeBet &&
										(
											<>
												<h4>{labels?.lbl_RPUsageRules}</h4>
												<ol>
													<li>{labels?.lbl_RPVoucherRules1}</li>
													<li>{labels?.lbl_RPVoucherRules2}</li>
													<li>{labels?.lbl_RPVoucherRules17}</li>
													<li>{labels?.lbl_RPVoucherRules5}</li>
													<li>{labels?.lbl_RPVoucherRules6}</li>
													<li>{labels?.lbl_RPVoucherRules7}</li>
													<li>{labels?.lbl_RPVoucherRules8}</li>
													<li>{labels?.lbl_RPVoucherRules9}</li>
													<li>{labels?.lbl_RPVoucherRules19}</li>
												</ol>
											</>
										)
									}
									{
										cartVoucher?.VoucherType == VoucherType.CashExchange &&
										<>
											<h4>{labels?.lbl_RPCashRedemptionRules}</h4>
											<p>{labels?.lbl_RPVoucherRules18}</p>
										</>
									}
								</div>
							)
						}
						{
							cartVoucher?.VoucherType == VoucherType.NicknameChange && (
								<div className="shop-voucher-detail__body reward-scroller">
									<h4>{labels?.lbl_SBCDescription01}</h4>
									<p>{labels?.lbl_nicknamechg1}</p>
									<h4>{labels?.lbl_RPUsageRules}</h4>
									<ol>
										<li>{labels?.lbl_nicknameduct}</li>
										<li>{labels?.lbl_nicknameusetime}</li>
									</ol>
								</div>
							)
						}
						{/*無兌換功能時，請移除 shop-voucher-detail__footer 結構*/}
						<div className="shop-voucher-detail__footer">
							<button
								ref={buttonRef}
								className="reward-btn reward-btn--primary"
								type="button"
								disabled={status !== 'canBuy'}
								onClick={purchase}
							>
								<div className="reward-btn__info">
									<span className="reward-btn__text">
										{
											{
												'canBuy': cartVoucher?.LimitPerPeriod ? labels?.lbl_RPConfirmRedeem : labels?.lbl_Confirmexchange,
												'noPermission': labels?.lbl_RPInsufficientLevel,
												'outOfMoney': labels?.lbl_RPNoSabaCoins,
												'reachLimit': labels?.lbl_RPLimitReached,
												'soldOut': labels?.lbl_RPVoucherSoldOut
											}[status]
										}
									</span>
								</div>
							</button>
						</div>
					</div>
					<div className="shop-voucher-icon">
						<i className={{
							[VoucherType.OddsBooster]: 'reward-icon-voucher-oddsboost',
							[VoucherType.RiskFreeBet]: 'reward-icon-voucher-shield',
							[VoucherType.CashExchange]: 'reward-icon-voucher-exchange',
							[VoucherType.NicknameChange]: 'reward-icon-voucher-edit',
							[VoucherType.BetterCashExchange]: 'reward-icon-voucher-exchange',
							[VoucherType.BestCashExchange]: 'reward-icon-voucher-exchange',
							[VoucherType.NewRiskFreeBet]: 'reward-icon-voucher-shield',
							[VoucherType.StandardCashExchange]: 'reward-icon-voucher-exchange',
							[VoucherType.GoodCashExchange]: 'reward-icon-voucher-exchange',
						}[cartVoucher?.VoucherType as number]}
						/>
					</div>
				</div>
			</div>
		</RewardModalWrapper>
	);
};